import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

import { ButtonStyleProps } from "./Button.constants";

const BaseButton = styled.button<ButtonStyleProps>`
  width: ${({ width }) => width || "100%"};
  height: ${({ IconSrc, height }) => {
    // if (IconSrc) return '38px';

    if (height) return height;

    return "55px";
  }};

  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  white-space: nowrap;
  vertical-align: middle;

  cursor: pointer;
  outline: none;

  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
    pointer-events: none;
  }

  ${({ isLoading }) =>
    isLoading &&
    `
    opacity: 0.7;
    cursor: not-allowed;
    pointer-events: none;
  `};

  &:focus {
    box-shadow: 0 0 4px 0px #515151;
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    height: ${({ height }) => height || "45px"};
  }
`;

const ButtonColors = {
  base: {
    primary: {
      backgroundColor: DIGIPOSTHEME.colors.primaryAkbankRed,
      color: DIGIPOSTHEME.colors.white,
      boxShadow: DIGIPOSTHEME.colors.white,
    },
    light: {
      backgroundColor: DIGIPOSTHEME.colors.white,
      color: DIGIPOSTHEME.colors.red,
      boxShadow: DIGIPOSTHEME.colors.white,
    },
    secondary: {
      backgroundColor: DIGIPOSTHEME.colors.secondary,
      color: "",
      boxShadow: DIGIPOSTHEME.colors.white,
    },
  },
  hover: {
    primary: {
      backgroundColor: DIGIPOSTHEME.colors.cherryRed,
      color: DIGIPOSTHEME.colors.white,
    },
    light: {
      backgroundColor: DIGIPOSTHEME.colors.white,
      color: DIGIPOSTHEME.colors.primaryAkbankRed,
    },
    secondary: {
      backgroundColor: DIGIPOSTHEME.colors.cherryRed,
      color: DIGIPOSTHEME.colors.white,
    },
  },
  focus: {
    primary: {
      backgroundColor: DIGIPOSTHEME.colors.strawberryRed,
    },
    light: {
      backgroundColor: DIGIPOSTHEME.colors.strawberryRed,
    },
    secondary: {
      backgroundColor: DIGIPOSTHEME.colors.cherryRed,
    },
  },
};

// eslint-disable-next-line import/prefer-default-export
export const StyledButton = styled(BaseButton)`
  ${({ float }) => float && `float: ${float};`};
  ${({ margin }) => margin && `margin: ${margin};`};
  ${({ margin }) => margin && `margin: ${margin};`};

  ${({ IconSrc }) => IconSrc && "padding: 0 20px 0 20px;"};

  background-color: ${({ color = "primary" }) =>
    ButtonColors.base[color].backgroundColor};

  ${({ introIsOpen }) =>
    introIsOpen &&
    `animation: buttonShadow 1.2s infinite;animation-fill-mode: infinite;animation-delay: 0.2s;`};

  @keyframes buttonShadow {
    0% {
      box-shadow: 0px 0px 0px 0px #f8f8f8;
    }

    100% {
      box-shadow: 0px 0px 6px 3px #bc1a25;
    }
  }

  font-size: 14px;
  font-weight: 500;
  font-family: "Campton";
  line-height: 1.43;
  letter-spacing: 0.5px;
  text-align: center;
  color: ${({ color = "primary" }) => ButtonColors.base[color].color};

  border: solid 2px #dc0005;
  border-radius: 28px;

  cursor: pointer;

  &:hover {
    background-color: ${({ color = "primary" }) =>
      ButtonColors.hover[color].backgroundColor};

    color: ${({ color = "primary" }) => ButtonColors.hover[color].color};

    border: solid 2px #a50000;
  }
`;

export const StyledLoadSpinner = styled.div<{
  color?: "primary" | "light" | "secondary";
}>`
  display: flex;

  ::after {
    color: ${({ color = "primary" }) => {
      if (color === "light") {
        return "#a50000";
      }

      return "white";
    }};
    border: 0.125rem solid;
    border-left-color: rgba(220, 0, 5, 0);
    border-radius: 50%;
    animation-duration: 0.8s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    content: "";
    z-index: 2001;

    width: 16px;
    height: 16px;
    margin-right: 10px;
    animation: spin 2s linear infinite;
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;
